import React from 'react'
import Label from '../../atoms/Label'
import TextArea from '../../atoms/TextArea'
import style from "./style.scss";

const CommentFeedback = ({ labelVal, textAreaVal, textAreaPlaceHolder, textAreaChange }) => {
    return (
        <div className={style["comment-feedback-container"]}>
            <Label value={labelVal} classN={style["labelClass"]} />
            <TextArea value={textAreaVal} placeholder={textAreaPlaceHolder} classN={style["textAreaClass"]} handleChange={textAreaChange} />
        </div>
    )
}

export default CommentFeedback